import React from 'react';
import Modal from '../Common/Modal';

/* Занятие вне пробного доступа.

   Пробнику открыто по одному занятию каждого типа — ближайшие к сегодняшнему
   дню. Всё остальное он видит, но под замком: так понятно, что курс больше,
   и видно, за что платить. Отсюда же — прямой выход на куратора. */

const CURATOR_TG = 'informatic_artem';

const IcLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="10.5" width="16" height="10.5" rx="2.4" /><path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
  </svg>
);
const IcTelegram = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 3 2 10.5l6 2.5 2.5 6L14 15l6 6z" /><path d="m8 13 6-4" />
  </svg>
);
const IcCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);

const KIND = {
  webinar: 'вебинар',
  homework: 'домашнее задание',
  variant: 'вариант',
};

export default function LockedModal({ open, onClose, kind = 'webinar', title }) {
  return (
    <Modal isOpen={open} onClose={onClose} bare>
      <div className="lk-modal" onClick={e => e.stopPropagation()}>
        <button type="button" className="lk-x" onClick={onClose} aria-label="Закрыть">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
        </button>

        <div className="lk-ic"><IcLock /></div>

        <div className="lk-t">Это занятие в полном курсе</div>
        <div className="lk-s">
          {title ? <b>{title}</b> : `Этот ${KIND[kind] || 'материал'}`} открывается после оплаты.
          В пробном доступе есть по одному занятию каждого типа — ближайшие по расписанию.
        </div>

        <div className="lk-list">
          {['Все вебинары курса и записи разборов',
            'Домашние задания с проверкой куратором',
            'Варианты с автопроверкой и переводом баллов'].map(t => (
            <div key={t} className="lk-li"><span className="lk-li-ic"><IcCheck /></span>{t}</div>
          ))}
        </div>

        <a className="lk-btn" href={`https://t.me/${CURATOR_TG}`} target="_blank" rel="noopener noreferrer">
          <span className="lk-btn-ic"><IcTelegram /></span>
          <span className="lk-btn-tt">
            <span className="lk-btn-t">Написать куратору</span>
            <span className="lk-btn-s">@{CURATOR_TG}</span>
          </span>
        </a>

        <button type="button" className="lk-later" onClick={onClose}>Позже</button>
      </div>
    </Modal>
  );
}
